/** The file was automatically generated. Please do not modify manually */
import bg from './online.json';
export var strings_bg = bg;
